<ng-template #popoverTemplate>
  <app-content-block
    *ngIf="blocks"
    [blocks]="blocks"
    [environmentJSON]="{ viewportMode: false }">
  </app-content-block>
</ng-template>

<div *ngIf="config" class="xfwPopOver" container="body" placement="top" [ngbPopover]="popoverTemplate" triggers="mouseenter:mouseleave">
